import ONBOARDING_TOOLTIP_CLASS_NAME from '../../constants/tooltip';

const MuiTooltip = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      fontSize: 16,
      lineHeight: 1.25,
      fontWeight: 300,
      '&.white-tooltip': {
        backgroundColor: 'white',
        color: theme.palette.gray.A700,
        border: '2px solid',
        borderColor: theme.palette.primary.main,
        borderRadius: 12,
        padding: 2,
      },
      [`&.${ONBOARDING_TOOLTIP_CLASS_NAME}`]: {
        backgroundColor: theme.palette.gray.A700,
        borderRadius: 8,
        '& .MuiTypography-root': {
          backgroundColor: 'inherit',
          color: 'inherit',
          fontSize: 'inherit',
          padding: 1,
        },
      },
    }),
    arrow: ({ theme }) => ({
      '&.white-tooltip': {
        color: theme.palette.primary.main,

      },
    }),
  },
};

export default MuiTooltip;
